import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import routes from './routes';
import Layout from './Layout';
import AuthService from '../services/AuthService';



const AppRouter = () => {
    const isAuthenticated = AuthService.getCurrentUser();
    const basePath = process.env.REACT_APP_BASE_PATH;

    return (
        <Router basename={basePath}>
            <Routes>
                <Route path="/" element={<Navigate to="/dashboard" />} />
                {routes.map((route, index) => {
                    const Component = route.component;
                    const requiresAuth = route.meta.requiresAuth;
                    const permission = route.meta.permission;
                    const hideHeader = route.meta.hideHeader;

                    // Check permission (only if authenticated and permission is specified)
                    const hasPermission = !permission || !isAuthenticated || AuthService.hasPermission(permission);

                    return (
                        <Route
                            key={index}
                            path={route.path}
                            element={
                                requiresAuth && !isAuthenticated ? (
                                    <Navigate to="/login" />
                                ) : requiresAuth && !hasPermission ? (
                                    <Navigate to="/dashboard" />
                                ) : (
                                    <Layout hideHeader={hideHeader} hasPermission={hasPermission}>
                                        <Component />
                                    </Layout>
                                )
                            }
                        />
                    );
                })}
            </Routes>
        </Router>
    );
};

export default AppRouter;
